import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { useWorkspaceId } from '@trello/id-context';
import { useSharedState } from '@trello/shared-state';

import { LazyRovoButton } from 'app/src/components/RovoButton';
import { cardBackSharedState } from './cardBackSharedState';

const ROVO_PANEL_COMBINED_MIN_WIDTH = 748;

export const CardBackRovoButton: FunctionComponent = () => {
  const workspaceId = useWorkspaceId() ?? '';
  const [{ activePanel, isPanelOpen, showRovo }] =
    useSharedState(cardBackSharedState);
  const { value: isSeparatePanelEnabled } = useFeatureGate(
    'trello_enterprise_rovo_chat_in_separate_panel',
  );

  const isActive = isSeparatePanelEnabled
    ? showRovo
    : activePanel === 'rovo' && isPanelOpen;

  const togglePanel = () => {
    if (isSeparatePanelEnabled) {
      const nextShowRovo = !showRovo;
      const isNarrowViewport =
        window.innerWidth < ROVO_PANEL_COMBINED_MIN_WIDTH;

      cardBackSharedState.setValue({
        showRovo: nextShowRovo,
        ...(nextShowRovo && isNarrowViewport ? { isPanelOpen: false } : {}),
      });
    } else {
      const panelOpen = activePanel === 'rovo' ? !isPanelOpen : true;
      cardBackSharedState.setValue({
        activePanel: 'rovo',
        isPanelOpen: panelOpen,
        shouldScrollIntoView: panelOpen,
      });
    }
  };

  return (
    <LazyRovoButton
      isActive={isActive}
      onClick={togglePanel}
      source="cardDetailScreen"
      workspaceId={workspaceId}
      isCardBackButton
    />
  );
};
